import { render, staticRenderFns } from "./roomsTop2.vue?vue&type=template&id=66505954&scoped=true"
import script from "./roomsTop2.vue?vue&type=script&lang=js"
export * from "./roomsTop2.vue?vue&type=script&lang=js"
import style0 from "./roomsTop2.vue?vue&type=style&index=0&id=66505954&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66505954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66505954')) {
      api.createRecord('66505954', component.options)
    } else {
      api.reload('66505954', component.options)
    }
    module.hot.accept("./roomsTop2.vue?vue&type=template&id=66505954&scoped=true", function () {
      api.rerender('66505954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/roomsTop2.vue"
export default component.exports